import JavascriptDataType from "../../utils/stringLiterals/JavascriptDataType";


const setItemStorage = function (key, valueString) {
    if(typeof(Storage) !== JavascriptDataType.UNDEFINED){       
        window.localStorage.setItem(key, valueString);
    }
}

const getItemStorage = function(key){
    return window.localStorage.getItem(key);
}

const getKeyNameStorage = function(index){
    let keyName = window.localStorage.key(index);
    return keyName;
}

const removeItemStorage = function(key){
    try{
        window.localStorage.removeItem(key);
        return "ok";
    }catch(error)
    {
        //console.log("removeItemStorage-error" , error);
        return "error";
    }    
}

const clearAllItemsStorage = function(){
    window.localStorage.clear();
}

const LocalStorageHelper = Object.freeze({
    setItemStorage: setItemStorage,
    getItemStorage: getItemStorage,
    getKeyNameStorage: getKeyNameStorage,
    removeItemStorage: removeItemStorage,
    clearAllItemsStorage: clearAllItemsStorage
});

export default LocalStorageHelper;